import { useEffect } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { useProjectType } from '@atlassian/jira-project-context-service/src/main.tsx';
import type { PracticeQueueRouteParams } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/project-sidebar-navigation-resource/types.tsx';
import type { UseResourceCustomContext } from '@atlassian/jira-resource-with-custom-router-context/src/controllers/types.tsx';
import { useResourceWithCustomRouterContext } from '@atlassian/jira-resource-with-custom-router-context/src/controllers/use-resource-with-custom-router-context/index.tsx';
import { serviceDeskContextResource } from '@atlassian/jira-router-resources-service-desk-context/src/services/index.tsx';

const getServiceDeskContextResource = () => serviceDeskContextResource;

export const useServiceDeskContext = (
	projectKey?: string,
	customContext?: UseResourceCustomContext<PracticeQueueRouteParams>,
	options?: {
		shouldPrefetch?: boolean;
	},
) => {
	let projectType: string | undefined;
	if (fg('jpx-197-servicedeskcontext-check-project-type')) {
		// eslint-disable-next-line react-hooks/react-compiler
		// eslint-disable-next-line react-hooks/rules-of-hooks
		projectType = useProjectType(projectKey ?? '');
	}

	const {
		data,
		loading,
		error,
		refresh: refreshCache,
	} = useResourceWithCustomRouterContext(
		getServiceDeskContextResource(),
		customContext,
		fg('handle_context_panel_issue_navigator_path') ? options : undefined,
	);

	useEffect(() => {
		if (!__SERVER__) {
			if (fg('jpx-197-servicedeskcontext-check-project-type')) {
				// Only refresh cache if project type is SERVICE_DESK_PROJECT
				if (projectType === SERVICE_DESK_PROJECT) {
					refreshCache();
				}
			} else {
				// Legacy behavior - always refresh cache
				refreshCache();
			}
		}
	}, [projectKey, refreshCache, projectType]);

	return [{ data, loading, error }] as const;
};
